import * as React from 'react';
import './Modal.scss';
import {styled} from '@mui/material/styles';
import {TextButton} from '../TextButton';

export const ModalTitle = styled('h3')({
  lineHeight: '40px',
  margin: 0,
});

export const ModalContent = styled('div')({
  marginTop: '20px',
  textAlign: 'center',
  color: '#474747',
});

const BlackX = styled(TextButton)({
  color: 'black',
  cursor: 'pointer',
  fontSize: '20px',
  fontWeight: 500,
});

const ModalHeaderBar = styled('div')({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  borderRadius: '7px 7px 0 0',
  backgroundColor: '#f1f2f2',
  fontSize: '20px',
  color: 'var(--template-color-2)',

  '& > span': {
    fontSize: '25px',
  },
});

export const EscapeX: React.FC<{
  close: () => unknown;
  style?: React.CSSProperties;
}> = ({close, ...props}) => (
  <BlackX onClick={close} {...props}>
    &#x2715;
  </BlackX>
);

export const ModalHeader = ({children}: {children: React.ReactNode}) => (
  <ModalHeaderBar className="Modal__HeaderBar">{children}</ModalHeaderBar>
);
